import React, { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  withHandlers,
  lifecycle
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import ReactSelectMaterialUi from 'react-select-material-ui';
import Typography from '@material-ui/core/Typography';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Modal from '@material-ui/core/Modal';
import { Link, ListItem, Select } from '@material-ui/core';
import RequiredButton from '../../components/atoms/RequiredButton';
import AnyButton from '../../components/atoms/AnyButton';
import ValidationText from '../../components/atoms/ValidationText';
import CancelButton from '../../components/atoms/CancelButton';
import ConfirmButton from '../../components/atoms/ConfirmButton';
import GroupEditConfirm from './GroupEditConfirm';
import FileUpload from '../../components/molecules/FileUpload';
import {
  getGroupDetail,
  editGroup,
  countGroupEmail,
  addGroupImage
} from '../../actions/Groups';
import { getZipCode } from '../../actions/Shop';
import { sendLogin, resizeImage, uploadFile } from '../../auth/Auth';
import { getAccounts } from '../../actions/Accounts';
import { getOptionCities } from '../../actions/Cities';
import { languages, languageType } from '../../constants/Language';

const styles = {
  root: {
    position: 'absolute',
    width: '85%',
    height: 'auto',
    maxHeight: '80%',
    top: '5%',
    left: '2%',
    backgroundColor: '#fff',
    padding: 28,
    overflow: 'scroll',
    outline: 'none'
  },
  pageTitle: {
    margin: '20px 0px 0px',
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  mainPaper: {
    position: 'relative',
    margin: '1px 0px 10px',
    padding: '10px 26px 10px 26px'
  },
  description: {
    color: '#707070',
    margin: '20px 0px 0px'
  },
  editTable: {
    width: 'auto'
  },
  tableCell90: {
    width: '90%'
  },
  tableCellBorderNone: {
    borderBottom: 'none'
  },
  depositManageDiv: {
    paddingTop: '1.5rem'
  },
  discription: {
    fontSize: '0.875rem'
  },
  textField: {
    padding: '0px 5px 0px 5px'
  },
  button: {
    margin: '5px auto'
  },
  selectContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end'
  },
  select: {
    width: '300px'
  },
  disableInput: {
    backgroundColor: '#d9d9d9'
  },
  link: {
    textDecoration: 'underline'
  },
  font14: {
    fontSize: 14
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      cities: state.cities.listCities,
      prefectures: state.commons.prefectures
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getGroupDetail,
          editGroup,
          addGroupImage,
          countGroupEmail,
          getAccounts,
          getOptionCities,
          getZipCode
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openEditProgress', 'updateOpenEditProgress', false),
  withState('loading', 'updateLoading', false),
  withState('isEditSuccess', 'updateIsEditSuccess', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('groupId', 'setGroupId', ''),
  withState('groupName', 'setGroupName', ''),
  withState('countryCode', 'setCountryCode', ''),
  withState('zipCode', 'setZipCode', ''),
  withState('prefectureCode', 'setPrefectureCode', 0),
  withState('cityIdError', 'setCityIdError', ''),
  withState('city', 'setCity', ''),
  withState('cityId', 'setCityId', ''),
  // withState('cityName', 'setCityName', ''),
  // withState('cityNameError', 'setCityNameError', ''),
  withState('address', 'setAddress', ''),
  withState('building', 'setBuilding', ''),
  withState('phone', 'setPhone', ''),
  withState('fax', 'setFax', ''),
  withState('groupContactName', 'setGroupContactName', ''),
  withState('department', 'setDepartment', ''),
  withState('directPhone', 'setDirectPhone', ''),
  withState('groupType', 'setGroupType', 'CHAIN_SHOP'),
  withState('groupTypeStr', 'setGroupTypeStr', 'チェーン店'),
  withState('linkingShopMessage', 'setLinkingShopMessage', ''),
  withState('email', 'setEmail', ''),
  withState('updatedAt', 'setUpdatedAt', ''),
  withState('groupNameError', 'setGroupNameError', ''),
  withState('zipCodeError', 'setZipCodeError', ''),
  withState('cityError', 'setCityError', ''),
  withState('addressError', 'setAddressError', ''),
  withState('groupContactNameError', 'setGroupContactNameError', ''),
  withState('departmentError', 'setDepartmentError', ''),
  withState('directPhoneError', 'setDirectPhoneError', ''),
  withState('phoneError', 'setPhoneError', ''),
  withState('emailError', 'setEmailError', ''),
  withState('depositManage', 'setDepositManage', 'NOT_MANAGE'),
  withState(
    'depositManageStr',
    'setDepositManageStr',
    'グループでは入金管理を登録しない'
  ),
  withState('bankName', 'setBankName', ''),
  withState('bankBranchName', 'setBankBranchName', ''),
  withState('bankAccountType', 'setBankAccountType', 'SAVINGS'),
  withState('bankAccountTypeStr', 'setBankAccountTypeStr', '普通預金'),
  withState('bankAccountNumber', 'setBankAccountNumber', ''),
  withState('bankAccountNumberError', 'setBankAccountNumberError', ''),
  withState('bankAccountHolder', 'setBankAccountHolder', ''),
  withState('bankAccountHolderError', 'setBankAccountHolderError', ''),
  withState('stripeUseSwitchable', 'setStripeUseSwitchable', true),
  withState('images', 'setImages', null),
  withState('image1', 'setImage1', null),
  withState('previewImage1', 'setPreviewImage1', null),
  withState('image2', 'setImage2', null),
  withState('previewImage2', 'setPreviewImage2', null),
  withState('image3', 'setImage3', null),
  withState('previewImage3', 'setPreviewImage3', null),
  withState('image4', 'setImage4', null),
  withState('previewImage4', 'setPreviewImage4', null),
  withState('image5', 'setImage5', null),
  withState('previewImage5', 'setPreviewImage5', null),
  withState('description', 'setDescription', ''),
  withState('website', 'setWebsite', ''),
  withState('websiteError', 'setWebsiteError', ''),
  withState('isLanguage', 'setIsLanguage', 'ja'),
  withState('translateType', 'setTranslateType', 0),
  withState('multiLangData', 'setMultiLangData', {}),
  withState('cashAllowed', 'setCashAllowed', 0),
  withState('allowMenuPriceShashoku', 'setAllowMenuPriceShashoku', 0),
  withState('bankCode', 'setBankCode', ''),
  withState('bankCodeError', 'setBankCodeError', ''),
  withState('bankBranchCode', 'setBankBranchCode', ''),
  withState('bankBranchCodeError', 'setBankBranchCodeError', ''),
  withState('haveRegistrationId', 'setHaveRegistrationId', 0),
  withState('registrationId', 'setRegistrationId', 'T'),
  withState('registrationIdError', 'setRegistrationIdError', ''),

  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    }
  }),
  lifecycle({
    componentDidMount() {
      this.props.actions.getOptionCities().then(() => {
        this.props.setCity(this.props.editInput.city);
      });
      this.props.setGroupId(this.props.editInput.groupId);
      this.props.setGroupName(this.props.editInput.groupName);
      this.props.setCountryCode(this.props.editInput.countryCode);
      this.props.setZipCode(this.props.editInput.zipCode);
      this.props.setPrefectureCode(this.props.editInput.prefectureCode);
      this.props.setAddress(this.props.editInput.address);
      this.props.setBuilding(this.props.editInput.building);
      this.props.setPhone(this.props.editInput.phone);
      this.props.setFax(this.props.editInput.fax);
      this.props.setGroupContactName(this.props.editInput.groupContactName);
      this.props.setDepartment(this.props.editInput.department);
      this.props.setDirectPhone(this.props.editInput.directPhone);
      this.props.setGroupType(this.props.editInput.groupType);
      this.props.setGroupTypeStr(this.props.editInput.groupTypeStr);
      this.props.setDepositManage(this.props.editInput.depositManage);
      this.props.setDepositManageStr(this.props.editInput.depositManageStr);
      this.props.setBankName(this.props.editInput.bankAccount.bankName);
      this.props.setCashAllowed(
        (this.props.editInput.groupDetail &&
          this.props.editInput.groupDetail.cashAllowed) ||
          0
      );
      this.props.setAllowMenuPriceShashoku(
        this.props.editInput.groupDetail &&
          this.props.editInput.groupDetail.allowMenuPriceShashoku !== null &&
          this.props.editInput.groupDetail.allowMenuPriceShashoku !== undefined
          ? this.props.editInput.groupDetail.allowMenuPriceShashoku
          : 1
      );
      this.props.setBankBranchName(
        this.props.editInput.bankAccount.bankBranchName
      );
      this.props.setBankAccountType(
        this.props.editInput.bankAccount.bankAccountType === null
          ? 'SAVINGS'
          : this.props.editInput.bankAccount.bankAccountType
      );
      this.props.setBankAccountTypeStr(
        this.props.editInput.bankAccount.bankAccountTypeStr === null
          ? '普通預金'
          : this.props.editInput.bankAccount.bankAccountTypeStr
      );
      this.props.setBankAccountNumber(
        this.props.editInput.bankAccount.bankAccountNumber
      );
      this.props.setBankAccountHolder(
        this.props.editInput.bankAccount.bankAccountHolder
      );
      this.props.setStripeUseSwitchable(
        this.props.editInput.stripeUseSwitchable
      );
      this.props.setLinkingShopMessage(this.props.editInput.linkingShopMessage);
      this.props.setEmail(this.props.editInput.email);
      this.props.setUpdatedAt(this.props.editInput.updatedAt);
      this.props.setDescription(this.props.editInput.description);
      this.props.setWebsite(this.props.editInput.website);
      this.props.setBankCode(this.props.editInput.bankAccount.bankCode);
      this.props.setBankBranchCode(
        this.props.editInput.bankAccount.bankBranchCode
      );
      if (
        this.props.editInput.images &&
        typeof this.props.editInput.images[0] !== 'undefined'
      ) {
        this.props.setPreviewImage1(this.props.editInput.images[0].image);
      }
      if (
        this.props.editInput.images &&
        typeof this.props.editInput.images[1] !== 'undefined'
      ) {
        this.props.setPreviewImage2(this.props.editInput.images[1].image);
      }
      if (
        this.props.editInput.images &&
        typeof this.props.editInput.images[2] !== 'undefined'
      ) {
        this.props.setPreviewImage3(this.props.editInput.images[2].image);
      }
      if (
        this.props.editInput.images &&
        typeof this.props.editInput.images[3] !== 'undefined'
      ) {
        this.props.setPreviewImage4(this.props.editInput.images[3].image);
      }
      if (
        this.props.editInput.images &&
        typeof this.props.editInput.images[4] !== 'undefined'
      ) {
        this.props.setPreviewImage5(this.props.editInput.images[4].image);
      }
      if (this.props.editInput.registrationId) {
        this.props.setHaveRegistrationId(1);
        this.props.setRegistrationId(this.props.editInput.registrationId);
      } else {
        this.props.setHaveRegistrationId(0);
        this.props.setRegistrationId('T');
      }

      let dataFirst = {};
      const origilData = {
        groupName: null,
        address: null,
        building: null,
        groupContactName: null,
        department: null,
        description: null,
        linkingShopMessage: null,
        countryCode: null,
        zipCode: null,
        prefectureCode: null,
        city: null,
        cityId: null,
        phone: null,
        fax: null,
        directPhone: null,
        groupType: null,
        email: null,
        depositManage: null,
        bankAccount: null,
        updatedAt: null,
        website: null,
        cashAllowed: null,
        allowMenuPriceShashoku: null
      };

      dataFirst = origilData;

      console.log('EDIT INPUT: ', this.props.editInput);
      if (this.props.editInput.otherLanguages) {
        const str = JSON.stringify(this.props.editInput.otherLanguages);
        dataFirst.otherLanguages = JSON.parse(str);
      }
      languages.forEach(item => {
        if (item.value === languageType.ORIGIN) return;
        const translatedData = dataFirst.otherLanguages.find(
          el => el.language === item.value
        );
        if (!translatedData) {
          const other = {
            translateType: 0,
            language: item.value
          };
          dataFirst.otherLanguages.push(other);
        }
      });
      this.props.setMultiLangData(dataFirst);
    }
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    editInput,
    setDisplayGroupName,
    prefectures,
    checkSession,
    groupId,
    groupName,
    setGroupName,
    countryCode,
    zipCode,
    setZipCode,
    prefectureCode,
    setPrefectureCode,
    cities,
    city,
    setCity,
    cityId,
    setCityId,
    // cityName,
    // setCityName,
    address,
    setAddress,
    building,
    setBuilding,
    phone,
    setPhone,
    fax,
    setFax,
    groupContactName,
    setGroupContactName,
    department,
    setDepartment,
    directPhone,
    setDirectPhone,
    groupType,
    setGroupType,
    groupTypeStr,
    setGroupTypeStr,
    email,
    setEmail,
    depositManage,
    setDepositManage,
    depositManageStr,
    setDepositManageStr,
    bankName,
    setBankName,
    bankBranchName,
    setBankBranchName,
    bankAccountType,
    setBankAccountType,
    bankAccountTypeStr,
    setBankAccountTypeStr,
    bankAccountNumber,
    setBankAccountNumber,
    bankAccountHolder,
    setBankAccountHolder,
    stripeUseSwitchable,
    groupNameError,
    setGroupNameError,
    zipCodeError,
    setZipCodeError,
    // cityError,
    // setCityError,
    cityIdError,
    setCityIdError,
    addressError,
    setAddressError,
    groupContactNameError,
    setGroupContactNameError,
    departmentError,
    setDepartmentError,
    directPhoneError,
    setDirectPhoneError,
    phoneError,
    setPhoneError,
    emailError,
    setEmailError,
    bankAccountNumberError,
    setBankAccountNumberError,
    bankAccountHolderError,
    setBankAccountHolderError,
    updatedAt,
    updateOpenEditModal,
    openEditConfirm,
    updateOpenEditConfirm,
    openEditProgress,
    updateOpenEditProgress,
    loading,
    updateLoading,
    isEditSuccess,
    updateIsEditSuccess,
    resultMessage,
    setResultMessage,
    image1,
    setImage1,
    previewImage1,
    setPreviewImage1,
    image2,
    setImage2,
    previewImage2,
    setPreviewImage2,
    image3,
    setImage3,
    previewImage3,
    setPreviewImage3,
    image4,
    setImage4,
    previewImage4,
    setPreviewImage4,
    image5,
    setImage5,
    previewImage5,
    setPreviewImage5,
    description,
    setDescription,
    linkingShopMessage,
    setLinkingShopMessage,
    website,
    setWebsite,
    websiteError,
    setWebsiteError,
    isLanguage,
    setIsLanguage,
    multiLangData,
    setMultiLangData,
    translateType,
    setTranslateType,
    handleChangePage,
    cashAllowed,
    // setCashAllowed,
    allowMenuPriceShashoku,
    setAllowMenuPriceShashoku,
    bankCode,
    setBankCode,
    bankCodeError,
    setBankCodeError,
    listBank,
    bankBranchCode,
    setBankBranchCode,
    bankBranchCodeError,
    setBankBranchCodeError,
    listBankBranch,
    haveRegistrationId,
    setHaveRegistrationId,
    registrationId,
    setRegistrationId,
    registrationIdError,
    setRegistrationIdError
  }) => {
    const groupDisplayLimit =
      groupType === 'CAMPAIGN' ||
      groupType === 'OTHERS' ||
      groupType === 'GOCHI_KID';

    const otherData = {
      groupTypeStr,
      depositManageStr,
      bankName,
      bankBranchName,
      bankAccountTypeStr,
      bankAccountNumber,
      bankAccountHolder,
      previewImage1,
      previewImage2,
      previewImage3,
      previewImage4,
      previewImage5
    };

    const bankAccount = {
      bankName,
      bankBranchName,
      bankAccountType,
      bankAccountNumber,
      bankAccountHolder,
      bankCode,
      bankBranchCode
    };

    const getCurrentData = () => {
      const lang = isLanguage;
      let data = multiLangData;
      const origilParam = {
        groupName,
        address,
        building,
        groupContactName,
        department,
        description,
        linkingShopMessage,
        countryCode,
        zipCode,
        prefectureCode,
        city,
        cityId,
        phone,
        fax,
        directPhone,
        groupType,
        email,
        depositManage,
        bankAccount,
        updatedAt,
        website,
        groupDetail:
          groupType !== 'OTHERS'
            ? {
                groupDetailId:
                  editInput.groupDetail && editInput.groupDetail.groupDetailId,
                cashAllowed,
                allowMenuPriceShashoku
              }
            : undefined,
        registrationId: haveRegistrationId ? registrationId : undefined
      };

      const otherParam = {
        translateType,
        language: lang,
        params: {
          groupName,
          groupContactName,
          department,
          description
        }
      };
      // origin
      if (lang === languageType.ORIGIN) {
        data = { ...data, ...origilParam };
      } else {
        // other languages
        for (let index = 0; index < data.otherLanguages.length; index += 1) {
          if (data.otherLanguages[index].language === lang) {
            data.otherLanguages[index] = otherParam;
          }
        }
      }
      const str = JSON.stringify(data);
      return JSON.parse(str);
    };

    const setLanguage = v => {
      const lang = isLanguage;
      const data = getCurrentData();
      if (
        (v !== languageType.ORIGIN && lang === languageType.ORIGIN) ||
        (v !== languageType.ORIGIN && lang !== languageType.ORIGIN)
      ) {
        // origin to other or other to other lang
        for (let k = 0; k < multiLangData.otherLanguages.length; k += 1) {
          if (multiLangData.otherLanguages[k].language === v) {
            setGroupName(
              multiLangData.otherLanguages[k].params &&
                multiLangData.otherLanguages[k].params.groupName
                ? multiLangData.otherLanguages[k].params.groupName
                : ''
            );
            setGroupContactName(
              multiLangData.otherLanguages[k].params &&
                multiLangData.otherLanguages[k].params.groupContactName
                ? multiLangData.otherLanguages[k].params.groupContactName
                : ''
            );
            setDepartment(
              multiLangData.otherLanguages[k].params &&
                multiLangData.otherLanguages[k].params.department
                ? multiLangData.otherLanguages[k].params.department
                : ''
            );
            setDescription(
              multiLangData.otherLanguages[k].params &&
                multiLangData.otherLanguages[k].params.description
                ? multiLangData.otherLanguages[k].params.description
                : ''
            );
            setTranslateType(
              multiLangData.otherLanguages[k].translateType
                ? multiLangData.otherLanguages[k].translateType
                : 0
            );
          }
        }
      } else if (v === languageType.ORIGIN) {
        setGroupName(multiLangData.groupName);
        setGroupContactName(multiLangData.groupContactName);
        setDepartment(multiLangData.department);
        setDescription(multiLangData.description);
      }
      setIsLanguage(v);
      setMultiLangData(data);
    };

    const errors = {
      groupNameError,
      zipCodeError,
      // cityError,
      cityIdError,
      addressError,
      groupContactNameError,
      departmentError,
      directPhoneError,
      phoneError,
      emailError,
      bankAccountNumberError,
      bankAccountHolderError,
      websiteError,
      bankCodeError,
      bankBranchCodeError,
      registrationIdError
    };

    // const getZipCodeData = async zipcode => {
    //   await actions.getZipCode(zipcode).then(data => {
    //     setPrefectureCode(data.payload.prefectureCode);
    //     setCity(data.payload.city);
    //     setAddress(data.payload.address);
    //     setNewCityId(data.payload.city);
    //   });
    // };

    const checkCityName = () => {
      console.log('cityId', city);
      const chosenCityNameList = [];
      cities
        .filter(item => item.cityName && item.cityName === city)
        .forEach(item => {
          chosenCityNameList.push({
            label: item.cityName,
            value: String(item.cityId)
          });
        });
      if (chosenCityNameList.length > 0) {
        console.log('cityId', Number(chosenCityNameList[0].value));
        return Number(chosenCityNameList[0].value);
      }
      return Number(0);
    };

    useEffect(() => {
      setCityId(checkCityName());
    }, [city]);

    // const setNewCityId = newCity => {
    //   const chosenCityNameList = [];
    //   cities
    //     .filter(item => item.cityName && item.cityName === newCity)
    //     .forEach(item => {
    //       chosenCityNameList.push({
    //         label: item.cityName,
    //         value: String(item.cityId)
    //       });
    //     });
    //   if (chosenCityNameList.length > 0) {
    //     setCityId(Number(chosenCityNameList[0].value));
    //   }
    // };

    const validGroupName = () => {
      if (isLanguage !== languageType.ORIGIN && translateType === 0) {
        return 0;
      }
      const value = groupName;
      if (value.trim() === '') {
        setGroupNameError('必須項目です。');
        return 1;
      }
      setGroupNameError('');
      setGroupName(value);
      return 0;
    };
    const validZipCode = () => {
      const value = zipCode;
      if (value === '') {
        setZipCodeError('必須項目です。');
        return 1;
      }
      if (!/^\d{7}$/.test(value)) {
        setZipCodeError('0000000形式で入力してください。');
        return 1;
      }
      setZipCodeError('');
      setZipCode(value);
      // getZipCodeData(value);
      return 0;
    };
    const validZipCodeSubmit = () => {
      const value = zipCode;
      if (value === '') {
        setZipCodeError('必須項目です。');
        return 1;
      }
      if (!/^\d{7}$/.test(value)) {
        setZipCodeError('0000000形式で入力してください。');
        return 1;
      }
      setZipCodeError('');
      setZipCode(value);
      return 0;
    };
    // const validCity = () => {
    //   const value = city;
    //   if (value === '') {
    //     setCityError('必須項目です。');
    //     return 1;
    //   }
    //   setCityError('');
    //   setCity(value);
    //   return 0;
    // };
    const validCityId = () => {
      const value = cityId;
      if (value === 0) {
        setCityIdError('必須項目です。');
        return 1;
      }
      setCityIdError('');
      // setCityId(value);
      return 0;
    };
    const setCityNameData = id => {
      cities.forEach(item => {
        if (id === item.cityId) {
          setCity(item.cityName);
        }
      });
    };
    const validAddress = () => {
      const value = address.trim();
      if (value.trim() === '') {
        setAddressError('必須項目です。');
        return 1;
      }
      setAddressError('');
      setAddress(value);
      return 0;
    };
    const validGroupContactName = () => {
      if (isLanguage !== languageType.ORIGIN && translateType === 0) {
        return 0;
      }
      const value = groupContactName.trim();
      if (value.trim() === '') {
        setGroupContactNameError('必須項目です。');
        return 1;
      }
      setGroupContactNameError('');
      setGroupContactName(value);
      return 0;
    };
    const validDepartment = () => {
      if (isLanguage !== languageType.ORIGIN && translateType === 0) {
        return 0;
      }
      const value = department.trim();
      if (value === '') {
        setDepartmentError('必須項目です。');
        return 1;
      }
      setDepartmentError('');
      setDepartment(value);
      return 0;
    };
    const validDirectPhone = () => {
      const value = directPhone;
      if (value === '') {
        setDirectPhoneError('必須項目です。');
        return 1;
      }
      if (!/^\d+$/.test(value)) {
        setDirectPhoneError('数字をハイフン(-)なしで入力してください。');
        return 1;
      }
      setDirectPhoneError('');
      setDirectPhone(value);
      return 0;
    };
    const validPhone = () => {
      const value = phone;
      if (value === '') {
        setPhoneError('必須項目です。');
        return 1;
      }
      if (!/^\d+$/.test(value)) {
        setPhoneError('数字をハイフン(-)なしで入力してください。');
        return 1;
      }
      setPhoneError('');
      setPhone(value);
      return 0;
    };
    const validEmail = () => {
      const value = email;
      if (value === '') {
        setEmailError('必須項目です。');
        return 1;
      }
      setEmailError('');
      setEmail(value);
      return 0;
    };
    const validEmailCount = emailData => {
      const value = email;
      if (
        emailData.payload.totalCount > 0 &&
        editInput.email !== emailData.payload.groups[0].email
      ) {
        setEmailError('メールアドレスが既に登録されています。');
        return 1;
      }
      setEmailError('');
      setEmail(value);
      return 0;
    };

    const validBankAccountNumber = () => {
      const value = bankAccountNumber;
      if (depositManage === 'NONSELF') {
        if (!value) {
          setBankAccountNumberError('必須項目です。');
          return 1;
        }
        if (!/^\d{7}$/.test(value)) {
          setBankAccountNumberError('半角数字のみで7桁で入力してください。');
          return 1;
        }
      }
      if (depositManage === 'SELF') {
        if (
          !value &&
          ((bankName && bankName !== '') ||
            (bankBranchName && bankBranchName !== '') ||
            (bankAccountHolder && bankAccountHolder !== ''))
        ) {
          setBankAccountNumberError('必須項目です。');
          return 1;
        }
        if (value && !/^\d{7}$/.test(value)) {
          setBankAccountNumberError('半角数字のみで7桁で入力してください。');
          return 1;
        }
      }
      setBankAccountNumberError('');
      setBankAccountNumber(value);
      return 0;
    };

    const validBankAccountHolder = () => {
      const value = bankAccountHolder;
      if (depositManage === 'NONSELF') {
        if (!value) {
          setBankAccountHolderError('必須項目です。');
          return 1;
        }
        if (
          !/^[0-9a-zA-Z!-/:-@¥[-`{-~！-／：-＠［-｀｛-～、-〜”’・ー‐−―￥ァ-ヴ\x20\u3000]+$/.test(
            value
          )
        ) {
          setBankAccountHolderError('漢字/ひらがな以外で入力してください。');
          return 1;
        }
      }
      if (depositManage === 'SELF') {
        if (
          !value &&
          ((bankName && bankName !== '') ||
            (bankBranchName && bankBranchName !== '') ||
            (bankAccountNumber && bankAccountNumber !== ''))
        ) {
          setBankAccountHolderError('必須項目です。');
          return 1;
        }
        if (
          value &&
          !/^[0-9a-zA-Z!-/:-@¥[-`{-~！-／：-＠［-｀｛-～、-〜”’・ー‐−―￥ァ-ヴ\x20\u3000]+$/.test(
            value
          )
        ) {
          setBankAccountHolderError('漢字/ひらがな以外で入力してください。');
          return 1;
        }
      }
      setBankAccountHolderError('');
      setBankAccountHolder(value);
      return 0;
    };
    const validWebsite = () => {
      const value = website;
      const pattern = /(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-/]))?/;
      if (value && !pattern.test(value)) {
        setWebsiteError('URLを入力してください');
        return 1;
      }
      setWebsiteError('');
      setWebsite(value);
      return 0;
    };
    const getBankName = bankCodeValue => {
      let listBankName = [];
      listBankName = listBank.filter(bank => bank.bankCode === bankCodeValue);
      if (listBankName.length === 0) {
        setBankCodeError('データが正しくありません。');
        setBankName('');
        return false;
      }
      setBankName(listBankName[0].bankName);
      return true;
    };

    const getBankBranchName = bankBranchCodeValue => {
      let listBankBranchName = [];
      listBankBranchName = listBankBranch.filter(
        bankBranch => bankBranch.uniqueCode === bankCode + bankBranchCodeValue
      );
      if (listBankBranchName.length === 0) {
        setBankBranchCodeError('データが正しくありません。');
        setBankBranchName('');
        return false;
      }
      setBankBranchName(listBankBranchName[0].bankBranchName);
      return true;
    };

    const validBankCode = () => {
      const value = bankCode;
      if (depositManage === 'NONSELF') {
        if (!value) {
          setBankCodeError('必須項目です。');
          return 1;
        }
        if (!/^[0-9\b]+$/.test(value)) {
          setBankCodeError('データが正しくありません。');
          return 1;
        }
        if (value.length !== 4) {
          setBankCodeError('データが正しくありません。');
          return 1;
        }
        if (!getBankName(value)) {
          return 1;
        }
      }
      if (
        depositManage === 'SELF' &&
        ((bankBranchCode && bankBranchCode !== '') ||
          (bankAccountNumber && bankAccountNumber !== '') ||
          (bankAccountHolder && bankAccountHolder !== ''))
      ) {
        if (!value) {
          setBankCodeError('必須項目です。');
          return 1;
        }
        if (!/^[0-9\b]+$/.test(value)) {
          setBankCodeError('データが正しくありません。');
          return 1;
        }
        if (value.length !== 4) {
          setBankCodeError('データが正しくありません。');
          return 1;
        }
        if (!getBankName(value)) {
          return 1;
        }
      }
      setBankCodeError('');
      return 0;
    };

    const validBankBranchCode = () => {
      const value = bankBranchCode;
      if (depositManage === 'NONSELF') {
        if (!value) {
          setBankBranchCodeError('必須項目です。');
          return 1;
        }
        if (!/^[0-9\b]+$/.test(value)) {
          setBankBranchCodeError('データが正しくありません。');
          return 1;
        }
        if (value.length !== 3) {
          setBankBranchCodeError('データが正しくありません。');
          return 1;
        }
        if (!getBankBranchName(value)) {
          return 1;
        }
      }
      if (
        depositManage === 'SELF' &&
        ((bankCode && bankCode !== '') ||
          (bankAccountNumber && bankAccountNumber !== '') ||
          (bankAccountHolder && bankAccountHolder !== ''))
      ) {
        if (!value) {
          setBankBranchCodeError('必須項目です。');
          return 1;
        }
        if (!/^[0-9\b]+$/.test(value)) {
          setBankBranchCodeError('データが正しくありません。');
          return 1;
        }
        if (value.length !== 3) {
          setBankBranchCodeError('データが正しくありません。');
          return 1;
        }
        if (!getBankBranchName(value)) {
          return 1;
        }
      }
      setBankBranchCodeError('');
      return 0;
    };

    const validRegistrationId = () => {
      const value = registrationId;
      if (groupDisplayLimit) {
        return 0;
      }
      if (haveRegistrationId === 1) {
        const valueNumber = value.slice(1);
        if (!value || !valueNumber) {
          setRegistrationIdError('必須項目です。');
          return 1;
        }
        if (!/^\d+$/.test(valueNumber)) {
          setRegistrationIdError('半角数字のみ入力してください。');
          return 1;
        }
        if (valueNumber.length !== 13) {
          setRegistrationIdError('13桁の番号をご入力ください。');
          return 1;
        }
      }
      setRegistrationId(value);
      setRegistrationIdError('');
      return 0;
    };

    const valid = emailData => {
      let errorCount =
        validGroupName() +
        validZipCode() +
        validCityId() +
        validZipCodeSubmit() +
        validAddress() +
        validGroupContactName() +
        validDepartment() +
        validDirectPhone() +
        validPhone() +
        validEmail() +
        validWebsite() +
        validBankAccountNumber() +
        validBankAccountHolder() +
        validBankCode() +
        validBankBranchCode() +
        validRegistrationId();
      if (emailData) errorCount += validEmailCount(emailData);
      if (errorCount === 0) {
        return true;
      }
      return false;
    };

    const convertImages = () => {
      const imageArray = {
        0: {
          image: image1,
          imagePath: previewImage1
        },
        1: {
          image: image2,
          imagePath: previewImage2
        },
        2: {
          image: image3,
          imagePath: previewImage3
        },
        3: {
          image: image4,
          imagePath: previewImage4
        },
        4: {
          image: image5,
          imagePath: previewImage5
        }
      };
      return imageArray;
    };

    const convertGroupTypeStr = mode => {
      if (mode === 'CHAIN_SHOP') {
        setGroupTypeStr('チェーン店');
      } else if (mode === 'COMMERCIAL_COMPLEX') {
        setGroupTypeStr('商業施設');
      } else if (mode === 'CAMPAIGN') {
        setGroupTypeStr('キャンペーン');
      } else if (mode === 'GOCHI_KID') {
        setGroupTypeStr('こどもごちめし特別資金グループ');
      } else {
        setGroupTypeStr('その他/仮想店舗');
      }
    };
    const convertDepositManageStr = mode => {
      if (mode === 'NONSELF') {
        setDepositManageStr('銀行口座を登録する');
      } else if (mode === 'SELF') {
        setDepositManageStr('Stripeを登録する');
      } else {
        setDepositManageStr('グループでは入金管理を登録しない');
      }
    };
    const convertBankAccountTypeStr = mode => {
      if (mode === 'SAVINGS') {
        setBankAccountTypeStr('普通預金');
      } else {
        setBankAccountTypeStr('当座預金');
      }
    };

    const cancelAction = () => updateOpenEditModal(false);
    const confirmAction = async () => {
      const emailData = await actions
        .countGroupEmail(email)
        .then(data => checkSession(data));
      if (!valid(emailData)) {
        alert('登録情報を正しく入力してください。');
      } else {
        setCityNameData(cityId);
        updateOpenEditConfirm(true);
        setMultiLangData(getCurrentData());
      }
    };
    const backAction = () => updateOpenEditConfirm(false);
    const editAction = async () => {
      updateLoading(true);
      updateOpenEditProgress(true);
      const images = convertImages();
      const editedGroup = await actions
        .editGroup(groupId, multiLangData)
        .then(data => checkSession(data));
      const imagePaths = await Promise.all(
        Object.keys(images).map(async i => {
          if (images[i].image !== null) {
            let { image } = images[i];
            if (image.size > Number(process.env.REACT_APP_RESIZE_BORDER)) {
              const { resizeImageFile } = await resizeImage(image);
              image = resizeImageFile;
            }
            const imagePath = await uploadFile(
              'group',
              groupId,
              image,
              'public'
            );
            return imagePath;
          }
          if (images[i].imagePath !== null) {
            return images[i].imagePath;
          }
          return null;
        })
      );
      const addImages = imagePaths
        .filter(i => i !== null)
        .map((i, index) => {
          return { image: i, viewOrder: index };
        });
      if (Object.keys(addImages).length !== 0) {
        await actions
          .addGroupImage(groupId, {
            images: addImages
          })
          .then(data => checkSession(data));
      }
      if (editedGroup.type === 'EDIT_GROUP_SUCCESS') {
        updateIsEditSuccess(true);
        actions.getGroupDetail(groupId).then(data => {
          actions.getAccounts({ cognitoUserId: '' });
          checkSession(data);
          setDisplayGroupName(data.payload.groupName);
        });
        handleChangePage();
        setResultMessage('編集が完了しました。');
        updateLoading(false);
      } else if (editedGroup.payload.status === 409) {
        updateIsEditSuccess(false);
        setResultMessage(
          'このグループ種別を修正できません。グループのメニュー種類を再度ご確認ください。'
        );
        updateLoading(false);
      } else {
        updateIsEditSuccess(false);
        setResultMessage('編集に失敗しました。');
        updateLoading(false);
      }
    };

    const progressOkAction = () => {
      if (isEditSuccess) {
        updateOpenEditModal(false);
        updateOpenEditConfirm(false);
        updateOpenEditProgress(false);
      } else {
        updateOpenEditProgress(false);
      }
    };
    const getCitiesOptions = () => {
      const citiesOptions = [];
      const tmpObj = { label: '', value: '0' };
      if (!prefectureCode || prefectureCode === 0) {
        cities.forEach(item => {
          citiesOptions.push({
            label: item.cityName,
            value: String(item.cityId)
          });
        });
      } else {
        cities
          .filter(
            item =>
              item.prefCode && Number(item.prefCode) === Number(prefectureCode)
          )
          .forEach(item => {
            citiesOptions.push({
              label: item.cityName,
              value: String(item.cityId)
            });
          });
      }
      return { ...citiesOptions, tmpObj };
    };

    const handleChangeCity = (e, v) => {
      setCity(v.label);
      setCityId(e);
    };

    const handleChangeBankCode = value => {
      setBankCode(value);
      setBankName('');
      setBankBranchCode('');
      setBankBranchName('');
    };

    const disableEditGroupType = true;

    return (
      <div className={classes.root}>
        <div className={classes.pageTitle}>
          <Typography variant="h6">グループ運営会社編集</Typography>
        </div>
        <div className={classes.selectContainer}>
          <Select
            className={`${classes.textField} ${classes.select}`}
            value={isLanguage}
            onChange={e => {
              if (isLanguage === e.target.value) {
                return;
              }
              if (
                valid() ||
                (isLanguage !== languageType.ORIGIN && translateType === 0)
              ) {
                setLanguage(e.target.value);
              } else {
                alert('登録情報を正しく入力してください。');
              }
            }}
          >
            {languages.map(lang => (
              <MenuItem key={lang.value} value={lang.value}>
                {lang.label}
              </MenuItem>
            ))}
          </Select>
        </div>
        {isLanguage !== languageType.ORIGIN && (
          <ListItem className={classes.itemForm}>
            <Typography component="div" className={classes.formInput}>
              <RadioGroup
                value={translateType}
                onChange={e => {
                  setTranslateType(parseInt(e.target.value, 10));
                }}
              >
                <FormControlLabel
                  value={0}
                  control={<Radio color="primary" />}
                  label="GG翻訳を選択"
                />
                <FormControlLabel
                  value={1}
                  control={<Radio color="primary" />}
                  label="自分で文章入力"
                />
              </RadioGroup>
            </Typography>
          </ListItem>
        )}
        <Paper className={classes.mainPaper} elevation={1}>
          <Table className={classes.editTable}>
            <TableBody>
              <TableRow>
                <TableCell>
                  <RequiredButton />
                </TableCell>
                <TableCell className={classes.tableCell90}>
                  <TextField
                    required
                    fullWidth
                    label="運営会社名"
                    value={groupName}
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      setGroupName(e.target.value);
                    }}
                    onBlur={validGroupName}
                    inputProps={{
                      maxLength: 250
                    }}
                    disabled={
                      isLanguage !== languageType.ORIGIN && translateType === 0
                    }
                  />
                  {(isLanguage === languageType.ORIGIN ||
                    translateType === 1) && (
                    <ValidationText message={errors.groupNameError} />
                  )}
                </TableCell>
                <TableCell />
              </TableRow>
              {isLanguage === languageType.ORIGIN && (
                <TableRow>
                  <TableCell className={classes.tableCellBorderNone}>
                    <RequiredButton />
                  </TableCell>
                  <TableCell className={classes.tableCellBorderNone}>
                    <TextField
                      required
                      fullWidth
                      label="郵便番号"
                      defaultValue={editInput.zipCode}
                      className={classes.textField}
                      margin="normal"
                      onChange={e => {
                        setZipCode(e.target.value);
                      }}
                      onBlur={validZipCode}
                    />
                    <ValidationText message={errors.zipCodeError} />
                  </TableCell>
                  <TableCell className={classes.tableCellBorderNone} />
                </TableRow>
              )}
              {isLanguage === languageType.ORIGIN && (
                <TableRow>
                  <TableCell className={classes.tableCellBorderNone} />
                  <TableCell className={classes.tableCellBorderNone}>
                    <TextField
                      required
                      autoFocus
                      select
                      fullWidth
                      label="都道府県"
                      className={classes.textField}
                      margin="normal"
                      value={prefectureCode}
                      onChange={e => {
                        setPrefectureCode(e.target.value);
                        setCityId(Number(0));
                        setCity('');
                      }}
                      InputLabelProps={{
                        shrink: true
                      }}
                    >
                      {prefectures.map(item => {
                        return (
                          <MenuItem key={item.id} value={item.id}>
                            {item.name}
                          </MenuItem>
                        );
                      })}
                    </TextField>
                  </TableCell>
                  <TableCell className={classes.tableCellBorderNone} />
                </TableRow>
              )}
              {isLanguage === languageType.ORIGIN && (
                <TableRow>
                  <TableCell className={classes.tableCellBorderNone} />
                  <TableCell className={classes.tableCellBorderNone}>
                    {prefectureCode > 0 && (
                      <ReactSelectMaterialUi
                        required
                        label="市区町村*"
                        fullWidth
                        className={classes.textField}
                        defaultValue={String(checkCityName())}
                        value={String(cityId)}
                        options={getCitiesOptions()}
                        margin="normal"
                        onChange={handleChangeCity}
                        SelectProps={{
                          isClearable: true,
                          msgNoOptionsMatchFilter:
                            '名前が部分一致する店舗がありません'
                        }}
                        onBlur={validCityId}
                      />
                    )}
                    {(!prefectureCode || prefectureCode <= 0) && (
                      <ReactSelectMaterialUi
                        disabled
                        required
                        fullWidth
                        label="市区町村*"
                        className={classes.textField}
                        defaultValue={String(checkCityName())}
                        value={String(cityId)}
                        options={getCitiesOptions()}
                        margin="normal"
                        onChange={handleChangeCity}
                        SelectProps={{
                          isClearable: true,
                          msgNoOptionsMatchFilter:
                            '名前が部分一致する店舗がありません'
                        }}
                        onBlur={validCityId}
                      />
                    )}
                    {editInput.city && !cityId && checkCityName() <= 0 && (
                      <Typography variant="h7">
                        市区町村はまだ正規化されません。再度設定してください。
                      </Typography>
                    )}
                    <ValidationText message={errors.cityIdError} />
                  </TableCell>
                  <TableCell className={classes.tableCellBorderNone} />
                </TableRow>
              )}
              {isLanguage === languageType.ORIGIN && (
                <TableRow>
                  <TableCell className={classes.tableCellBorderNone} />
                  <TableCell className={classes.tableCellBorderNone}>
                    <TextField
                      required
                      fullWidth
                      label="町域・番地"
                      defaultValue={editInput.address}
                      value={address}
                      className={classes.textField}
                      margin="normal"
                      onChange={e => {
                        setAddress(e.target.value);
                      }}
                      onBlur={validAddress}
                      inputProps={{
                        maxLength: 250
                      }}
                      disabled={
                        isLanguage !== languageType.ORIGIN &&
                        translateType === 0
                      }
                    />
                    {(isLanguage === languageType.ORIGIN ||
                      translateType === 1) && (
                      <ValidationText message={errors.addressError} />
                    )}
                  </TableCell>
                  <TableCell className={classes.tableCellBorderNone} />
                </TableRow>
              )}
              {isLanguage === languageType.ORIGIN && (
                <TableRow>
                  <TableCell />
                  <TableCell>
                    <TextField
                      fullWidth
                      label="建物名"
                      value={building}
                      className={classes.textField}
                      margin="normal"
                      onChange={e => {
                        setBuilding(e.target.value);
                      }}
                      inputProps={{
                        maxLength: 250
                      }}
                      disabled={
                        isLanguage !== languageType.ORIGIN &&
                        translateType === 0
                      }
                    />
                  </TableCell>
                  <TableCell />
                </TableRow>
              )}
              {isLanguage === languageType.ORIGIN && (
                <TableRow>
                  <TableCell>
                    <RequiredButton />
                  </TableCell>
                  <TableCell>
                    <TextField
                      required
                      fullWidth
                      label="電話番号"
                      defaultValue={editInput.phone}
                      className={classes.textField}
                      margin="normal"
                      onChange={e => {
                        setPhone(e.target.value);
                      }}
                      onBlur={validPhone}
                    />
                    <ValidationText message={errors.phoneError} />
                  </TableCell>
                  <TableCell />
                </TableRow>
              )}
              {isLanguage === languageType.ORIGIN && (
                <TableRow>
                  <TableCell>
                    <AnyButton />
                  </TableCell>
                  <TableCell>
                    <TextField
                      label="FAX"
                      fullWidth
                      defaultValue={editInput.fax}
                      className={classes.textField}
                      margin="normal"
                      onChange={e => {
                        setFax(e.target.value);
                      }}
                    />
                  </TableCell>
                  <TableCell />
                </TableRow>
              )}
              {isLanguage === languageType.ORIGIN && (
                <TableRow>
                  <TableCell className={classes.tableCellBorderNone}>
                    <RequiredButton />
                  </TableCell>
                  <TableCell className={classes.tableCellBorderNone}>
                    店舗オーナーさまへの依頼）
                    <br />
                    店舗オーナーさまが登録された店舗の現場に連絡しても、
                    「ごちめし」のことを全く知らないという事例が発生してきています。
                    店舗登録時には現場の責任者に了解を取った後に登録ください。
                  </TableCell>
                </TableRow>
              )}
              <TableRow>
                <TableCell className={classes.tableCellBorderNone} />
                <TableCell className={classes.tableCellBorderNone}>
                  <TextField
                    required
                    label="ご担当者名"
                    value={groupContactName}
                    fullWidth
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      setGroupContactName(e.target.value);
                    }}
                    onBlur={validGroupContactName}
                    inputProps={{
                      maxLength: 250
                    }}
                    disabled={
                      isLanguage !== languageType.ORIGIN && translateType === 0
                    }
                  />
                  {(isLanguage === languageType.ORIGIN ||
                    translateType === 1) && (
                    <ValidationText message={errors.groupContactNameError} />
                  )}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tableCellBorderNone} />
                <TableCell className={classes.tableCellBorderNone}>
                  <TextField
                    required
                    label="所属部署"
                    value={department}
                    fullWidth
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      setDepartment(e.target.value);
                    }}
                    onBlur={validDepartment}
                    inputProps={{
                      maxLength: 250
                    }}
                    disabled={
                      isLanguage !== languageType.ORIGIN && translateType === 0
                    }
                  />
                  {(isLanguage === languageType.ORIGIN ||
                    translateType === 1) && (
                    <ValidationText message={errors.departmentError} />
                  )}
                </TableCell>
              </TableRow>
              {isLanguage === languageType.ORIGIN && (
                <TableRow>
                  <TableCell />
                  <TableCell>
                    <TextField
                      required
                      label="電話番号（直通等）"
                      defaultValue={editInput.directPhone}
                      fullWidth
                      className={classes.textField}
                      margin="normal"
                      onChange={e => {
                        setDirectPhone(e.target.value);
                      }}
                      onBlur={validDirectPhone}
                    />
                    <ValidationText message={errors.directPhoneError} />
                  </TableCell>
                </TableRow>
              )}
              {isLanguage === languageType.ORIGIN && !groupDisplayLimit && (
                <>
                  <TableRow>
                    <TableCell
                      className={[classes.tableCellBorderNone, classes.colLeft]}
                    >
                      <RequiredButton />
                    </TableCell>
                    <TableCell
                      className={[
                        classes.tableCellBorderNone,
                        classes.colRight
                      ]}
                    >
                      <Typography>インボイス制度 適格事業者登録*</Typography>
                      <RadioGroup
                        row
                        value={haveRegistrationId}
                        onChange={e => {
                          setHaveRegistrationId(parseInt(e.target.value, 10));
                        }}
                      >
                        <FormControlLabel
                          value={0}
                          control={<Radio color="primary" />}
                          label="未登録"
                        />
                        <FormControlLabel
                          value={1}
                          control={<Radio color="primary" />}
                          label="登録済み"
                        />
                      </RadioGroup>
                    </TableCell>
                  </TableRow>
                  {haveRegistrationId === 1 && (
                    <TableRow>
                      <TableCell
                        className={[
                          classes.tableCellBorderNone,
                          classes.colLeft
                        ]}
                      />
                      <TableCell
                        className={[
                          classes.tableCellBorderNone,
                          classes.colRight
                        ]}
                      >
                        <TextField
                          required
                          label="適格事業者登録番号"
                          className={classes.textField}
                          onChange={e => {
                            if (e.target.value[0] === 'T') {
                              setRegistrationId(e.target.value);
                            } else if (!e.target.value) {
                              setRegistrationId('T');
                            }
                          }}
                          value={registrationId}
                          onBlur={validRegistrationId}
                          InputLabelProps={{
                            shrink: true
                          }}
                          fullWidth
                        />
                        <ValidationText message={errors.registrationIdError} />
                        <Typography variant="h7">
                          Tの後に続く13桁の番号を入力してください。
                        </Typography>
                      </TableCell>
                    </TableRow>
                  )}
                </>
              )}
              {isLanguage === languageType.ORIGIN && (
                <TableRow>
                  <TableCell
                    className={[classes.tableCellBorderNone, classes.colLeft]}
                  >
                    <AnyButton />
                  </TableCell>
                  <TableCell
                    className={[classes.tableCellBorderNone, classes.colRight]}
                  >
                    <FileUpload
                      label="image1"
                      setFile={setImage1}
                      previewImage={previewImage1}
                      setPreviewImage={setPreviewImage1}
                    />
                    <FileUpload
                      label="image2"
                      setFile={setImage2}
                      previewImage={previewImage2}
                      setPreviewImage={setPreviewImage2}
                    />
                    <FileUpload
                      label="image3"
                      setFile={setImage3}
                      previewImage={previewImage3}
                      setPreviewImage={setPreviewImage3}
                    />
                    <FileUpload
                      label="image4"
                      setFile={setImage4}
                      previewImage={previewImage4}
                      setPreviewImage={setPreviewImage4}
                    />
                    <FileUpload
                      label="image5"
                      setFile={setImage5}
                      previewImage={previewImage5}
                      setPreviewImage={setPreviewImage5}
                    />
                  </TableCell>
                </TableRow>
              )}
              <TableRow>
                <TableCell>
                  <AnyButton />
                </TableCell>
                <TableCell>
                  <TextField
                    label="グループの概要"
                    fullWidth
                    defaultValue={editInput.description}
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      setDescription(e.target.value);
                    }}
                    inputProps={{
                      maxLength: 250
                    }}
                    value={description}
                    disabled={
                      isLanguage !== languageType.ORIGIN && translateType === 0
                    }
                  />
                </TableCell>
                <TableCell />
              </TableRow>
              {isLanguage === languageType.ORIGIN && (
                <TableRow>
                  <TableCell>
                    <AnyButton />
                  </TableCell>
                  <TableCell>
                    <TextField
                      label="WebページURL"
                      fullWidth
                      defaultValue={editInput.website}
                      className={classes.textField}
                      margin="normal"
                      onChange={e => {
                        setWebsite(e.target.value);
                      }}
                      onBlur={validWebsite}
                    />
                    <ValidationText message={errors.websiteError} />
                  </TableCell>
                  <TableCell />
                </TableRow>
              )}
              {isLanguage === languageType.ORIGIN && (
                <TableRow>
                  <TableCell className={classes.tableCellBorderNone}>
                    <RequiredButton />
                  </TableCell>
                  <TableCell className={classes.tableCellBorderNone}>
                    <Typography className={classes.description}>
                      グループ種別
                    </Typography>
                    <RadioGroup
                      row
                      value={groupType}
                      onChange={e => {
                        setGroupType(e.target.value);
                        convertGroupTypeStr(e.target.value);
                      }}
                    >
                      <FormControlLabel
                        value="CHAIN_SHOP"
                        disabled={disableEditGroupType}
                        control={<Radio color="primary" />}
                        label="チェーン店"
                      />
                      <FormControlLabel
                        value="COMMERCIAL_COMPLEX"
                        disabled={disableEditGroupType}
                        control={<Radio color="primary" />}
                        label="商業施設"
                      />
                      <FormControlLabel
                        value="CAMPAIGN"
                        disabled={disableEditGroupType}
                        control={<Radio color="primary" />}
                        label="キャンペーン"
                      />
                      <FormControlLabel
                        value="OTHERS"
                        disabled={disableEditGroupType}
                        control={<Radio color="primary" />}
                        label="その他/仮想店舗"
                      />
                      <FormControlLabel
                        value="GOCHI_KID"
                        disabled={disableEditGroupType}
                        control={<Radio color="primary" />}
                        label="こどもごちめし特別資金グループ"
                      />
                    </RadioGroup>
                  </TableCell>
                </TableRow>
              )}
              {isLanguage === languageType.ORIGIN && (
                <TableRow>
                  <TableCell />
                  <TableCell>
                    [チェーン店]
                    <br />
                    同一（あるいは複数）ブランドの直営・フランチャイズ展開を実施している場合に選択ください。
                    <br />
                    <br />
                    [商業施設]
                    <br />
                    経営会社が異なる複数ブランドを束ねた施設を運営している場合に選択ください。
                    <br />
                    <br />
                    [キャンペーン]
                    <br />
                    自治体案件や、期間限定キャンペーンなどに該当する場合に選択してください。
                    <br />
                    <br />
                    [その他/仮想店舗]
                    <br />
                    子ども食堂、災害時支援など、上記と異なる用途の場合に選択ください。
                    <br />
                    <br />
                    [こどもごちめし特別資金グループ]
                    <br />
                    こどもごちめし特別資金グループに該当する場合に選択してください。
                  </TableCell>
                </TableRow>
              )}
              {isLanguage === languageType.ORIGIN && (
                <>
                  <TableRow>
                    <TableCell>
                      <AnyButton />
                    </TableCell>
                    <TableCell>
                      <TextField
                        multiline
                        rows="3"
                        label="グループ紐付け時のメッセージ"
                        fullWidth
                        defaultValue={editInput.linkingShopMessage}
                        className={classes.textField}
                        margin="normal"
                        onChange={e => {
                          setLinkingShopMessage(e.target.value);
                        }}
                        inputProps={{
                          maxLength: 1000
                        }}
                        value={linkingShopMessage}
                      />
                    </TableCell>
                    <TableCell />
                  </TableRow>
                  <TableRow>
                    <TableCell className={classes.tableCellBorderNone} />
                    <TableCell className={classes.tableCellBorderNone}>
                      店舗をグループに紐づける時にメールが送信されます。対象店舗にグループ紐付け時にお伝えしたいメッセージを記載することができます。
                    </TableCell>
                  </TableRow>
                </>
              )}

              {isLanguage === languageType.ORIGIN && (
                <TableRow>
                  <TableCell className={classes.tableCellBorderNone}>
                    <RequiredButton />
                  </TableCell>
                  <TableCell className={classes.tableCellBorderNone}>
                    <TextField
                      required
                      fullWidth
                      label="メールアドレス"
                      defaultValue={editInput.email}
                      className={classes.textField}
                      margin="normal"
                      InputProps={{
                        readOnly: true
                      }}
                      onChange={e => {
                        setEmail(e.target.value);
                      }}
                      onBlur={validEmail}
                    />
                    <ValidationText message={errors.emailError} />
                  </TableCell>
                  <TableCell className={classes.tableCellBorderNone} />
                </TableRow>
              )}
              {isLanguage === languageType.ORIGIN && (
                <TableRow>
                  <TableCell />
                  <TableCell>
                    メールアドレスは、ごちめしの各種ご連絡、および、管理システムのIDとしても利用いたします。
                    メールアドレスの変更を行いたい場合には、画面右上のメニュー(人マーク)の「メールアドレス変更」より行ってください。
                  </TableCell>
                </TableRow>
              )}
              {isLanguage === languageType.ORIGIN && !groupDisplayLimit && (
                <TableRow>
                  <TableCell className={classes.tableCellBorderNone}>
                    <RequiredButton />
                  </TableCell>
                  <TableCell className={classes.tableCellBorderNone}>
                    <Typography component="p" className={classes.description}>
                      入金管理
                    </Typography>
                    <RadioGroup
                      value={depositManage}
                      onChange={e => {
                        setDepositManage(e.target.value);
                        convertDepositManageStr(e.target.value);
                      }}
                    >
                      <div>
                        <FormControlLabel
                          value="NOT_MANAGE"
                          control={<Radio color="primary" />}
                          label="グループでは入金管理を登録しない"
                          disabled={
                            !stripeUseSwitchable ||
                            editInput.groupAccountStatus.stripeAccount
                          }
                        />
                        <Typography className={classes.discription}>
                          グループの各店舗別に、入金する銀行口座を登録して頂きます。
                        </Typography>
                      </div>
                      <div className={classes.depositManageDiv}>
                        <FormControlLabel
                          value="NONSELF"
                          control={<Radio color="primary" />}
                          label="銀行口座を登録する"
                          disabled={
                            !stripeUseSwitchable ||
                            editInput.groupAccountStatus.stripeAccount
                          }
                        />
                        <Typography className={classes.discription}>
                          グループの全店舗の入金が同一の口座に振り込まれます。
                          <br />
                          また各店舗の登録情報に口座情報は掲載されません。
                          <br />
                          ※(注意)『自社で入金管理する』を選択している店舗をグループに紐付けると、店舗のstripe連携が外れます。
                        </Typography>
                      </div>
                      <div>
                        <FormControlLabel
                          value="SELF"
                          control={<Radio color="primary" />}
                          label="Stripeを登録する"
                          disabled={
                            !stripeUseSwitchable ||
                            editInput.groupAccountStatus.stripeAccount
                          }
                        />
                      </div>
                    </RadioGroup>
                  </TableCell>
                </TableRow>
              )}
              {/* {isLanguage === languageType.ORIGIN &&
                groupType !== 'OTHERS' &&
                !groupDisplayLimit && (
                  <TableRow>
                    <TableCell className={classes.colLeft}>
                      <RequiredButton />
                    </TableCell>
                    <TableCell className={classes.colRight}>
                      <Typography className={classes.description}>
                        社食ごちめし現金授受の有無
                      </Typography>
                      <RadioGroup
                        row
                        value={cashAllowed}
                        onChange={e => {
                          const allowed = parseInt(e.target.value, 10);
                          setCashAllowed(allowed);
                        }}
                      >
                        <FormControlLabel
                          value={0}
                          control={<Radio color="primary" />}
                          label="受け付けない"
                        />
                        <FormControlLabel
                          value={1}
                          control={<Radio color="primary" />}
                          label="受け付ける"
                        />
                      </RadioGroup>
                    </TableCell>
                  </TableRow>
                )} */}
              {isLanguage === languageType.ORIGIN &&
                groupType !== 'OTHERS' &&
                !groupDisplayLimit && (
                  <TableRow>
                    <TableCell className={classes.colLeft}>
                      <RequiredButton />
                    </TableCell>
                    <TableCell className={classes.colRight}>
                      <Typography className={classes.description}>
                        社食ごちめし金額指定チケット利用の有無
                      </Typography>
                      <RadioGroup
                        row
                        value={allowMenuPriceShashoku}
                        onChange={e => {
                          setAllowMenuPriceShashoku(
                            parseInt(e.target.value, 0)
                          );
                        }}
                      >
                        <FormControlLabel
                          value={1}
                          control={<Radio color="primary" />}
                          label="利用する"
                        />
                        <FormControlLabel
                          value={0}
                          control={<Radio color="primary" />}
                          label="利用しない"
                        />
                      </RadioGroup>
                    </TableCell>
                  </TableRow>
                )}
              {(depositManage === 'NONSELF' || depositManage === 'SELF') &&
                !groupDisplayLimit &&
                isLanguage === languageType.ORIGIN && (
                  <>
                    <TableRow>
                      <TableCell className={classes.tableCellBorderNone} />
                      <TableCell className={classes.tableCellBorderNone}>
                        <TextField
                          required
                          label="銀行コード"
                          defaultValue={editInput.bankAccount.bankCode}
                          placeholder="0000"
                          fullWidth
                          className={classes.textField}
                          margin="normal"
                          onChange={e => {
                            handleChangeBankCode(e.target.value);
                          }}
                          onBlur={validBankCode}
                          disabled={!stripeUseSwitchable}
                          inputProps={{
                            maxLength: 4,
                            inputMode: 'numeric'
                          }}
                          value={bankCode}
                        />
                        <Typography className={`${classes.font14}`}>
                          ※
                          <Link
                            href="https://zengin.ajtw.net/"
                            target="_blank"
                            className={classes.link}
                          >
                            検索サイト
                          </Link>
                        </Typography>
                        <Typography style={{ fontSize: 14 }}>
                          半角数字・4桁（3桁以下の方は、先頭に0をつけて4桁にしてください）
                        </Typography>
                        <ValidationText message={errors.bankCodeError} />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={classes.tableCellBorderNone} />
                      <TableCell className={classes.tableCellBorderNone}>
                        <TextField
                          label="銀行名"
                          defaultValue={editInput.bankAccount.bankName}
                          fullWidth
                          className={[classes.textField, classes.disableInput]}
                          margin="normal"
                          disabled
                          value={bankName}
                        />
                      </TableCell>
                    </TableRow>
                  </>
                )}
              {(depositManage === 'NONSELF' || depositManage === 'SELF') &&
                !groupDisplayLimit &&
                isLanguage === languageType.ORIGIN && (
                  <>
                    <TableRow>
                      <TableCell className={classes.tableCellBorderNone} />
                      <TableCell className={classes.tableCellBorderNone}>
                        <TextField
                          required
                          label="支店コード"
                          defaultValue={editInput.bankAccount.bankBranchCode}
                          placeholder="000"
                          fullWidth
                          className={classes.textField}
                          margin="normal"
                          onChange={e => {
                            setBankBranchCode(e.target.value);
                            setBankBranchName('');
                          }}
                          onBlur={validBankBranchCode}
                          disabled={!stripeUseSwitchable}
                          inputProps={{
                            maxLength: 3,
                            inputMode: 'numeric'
                          }}
                          value={bankBranchCode}
                        />
                        <Typography className={`${classes.font14}`}>
                          ※
                          <Link
                            href="https://zengin.ajtw.net/"
                            target="_blank"
                            className={classes.link}
                          >
                            検索サイト
                          </Link>
                        </Typography>
                        <Typography className={`${classes.font14}`}>
                          半角数字・3桁（2桁以下の方は、先頭に0をつけて3桁にしてください）
                        </Typography>
                        <ValidationText message={errors.bankBranchCodeError} />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={classes.tableCellBorderNone} />
                      <TableCell className={classes.tableCellBorderNone}>
                        <TextField
                          label="支店名"
                          defaultValue={editInput.bankAccount.bankBranchName}
                          fullWidth
                          className={[classes.textField, classes.disableInput]}
                          margin="normal"
                          disabled
                          value={bankBranchName}
                        />
                      </TableCell>
                    </TableRow>
                  </>
                )}
              {(depositManage === 'NONSELF' || depositManage === 'SELF') &&
                !groupDisplayLimit &&
                isLanguage === languageType.ORIGIN && (
                  <TableRow>
                    <TableCell className={classes.tableCellBorderNone} />
                    <TableCell className={classes.tableCellBorderNone}>
                      <Typography className={classes.description}>
                        口座種別
                      </Typography>
                      <RadioGroup
                        row
                        value={bankAccountType}
                        onChange={e => {
                          setBankAccountType(e.target.value);
                          convertBankAccountTypeStr(e.target.value);
                        }}
                      >
                        <FormControlLabel
                          value="SAVINGS"
                          control={<Radio color="primary" />}
                          label="普通預金"
                          disabled={!stripeUseSwitchable}
                        />
                        <FormControlLabel
                          value="CHECKING"
                          control={<Radio color="primary" />}
                          label="当座預金"
                          disabled={!stripeUseSwitchable}
                        />
                      </RadioGroup>
                    </TableCell>
                  </TableRow>
                )}
              {(depositManage === 'NONSELF' || depositManage === 'SELF') &&
                !groupDisplayLimit &&
                isLanguage === languageType.ORIGIN && (
                  <TableRow>
                    <TableCell className={classes.tableCellBorderNone} />
                    <TableCell className={classes.tableCellBorderNone}>
                      <TextField
                        required
                        label="口座番号"
                        defaultValue={editInput.bankAccount.bankAccountNumber}
                        placeholder="1234567"
                        fullWidth
                        className={classes.textField}
                        margin="normal"
                        onChange={e => {
                          setBankAccountNumber(e.target.value);
                        }}
                        onBlur={validBankAccountNumber}
                        disabled={!stripeUseSwitchable}
                      />
                      <ValidationText message={errors.bankAccountNumberError} />
                    </TableCell>
                  </TableRow>
                )}
              {(depositManage === 'NONSELF' || depositManage === 'SELF') &&
                !groupDisplayLimit &&
                isLanguage === languageType.ORIGIN && (
                  <TableRow>
                    <TableCell className={classes.tableCellBorderNone} />
                    <TableCell className={classes.tableCellBorderNone}>
                      半角数字・7桁（6桁以下の方は先頭に0をつけて7桁にしてください）
                    </TableCell>
                  </TableRow>
                )}
              {(depositManage === 'NONSELF' || depositManage === 'SELF') &&
                !groupDisplayLimit &&
                isLanguage === languageType.ORIGIN && (
                  <TableRow>
                    <TableCell className={classes.tableCellBorderNone} />
                    <TableCell className={classes.tableCellBorderNone}>
                      <TextField
                        required
                        label="口座名義"
                        defaultValue={editInput.bankAccount.bankAccountHolder}
                        placeholder="ヤマダ　タロウ"
                        fullWidth
                        className={classes.textField}
                        margin="normal"
                        onChange={e => {
                          setBankAccountHolder(e.target.value);
                        }}
                        onBlur={validBankAccountHolder}
                        disabled={!stripeUseSwitchable}
                      />
                      <ValidationText message={errors.bankAccountHolderError} />
                    </TableCell>
                  </TableRow>
                )}
              {(depositManage === 'NONSELF' || depositManage === 'SELF') &&
                !groupDisplayLimit &&
                isLanguage === languageType.ORIGIN && (
                  <TableRow>
                    <TableCell className={classes.tableCellBorderNone} />
                    <TableCell className={classes.tableCellBorderNone}>
                      必ず漢字/ひらがな以外でご記入ください。
                    </TableCell>
                  </TableRow>
                )}
            </TableBody>
          </Table>
        </Paper>
        <div>
          <CancelButton onClickAction={cancelAction} color="primary" />
          <ConfirmButton onClickAction={confirmAction} />
        </div>
        <Modal open={openEditConfirm}>
          <GroupEditConfirm
            backAction={backAction}
            editAction={editAction}
            otherData={otherData}
            editParam={multiLangData}
            openEditProgress={openEditProgress}
            progressOkAction={progressOkAction}
            loading={loading}
            resultMessage={resultMessage}
            currentLanguage={isLanguage}
            setIsLanguage={setIsLanguage}
          />
        </Modal>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
